/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Grid,
  TextField,
  Button,
  Box,
  IconButton,
} from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import { makeStyles } from "@material-ui/core/styles";
import { ThumbUp, ThumbDown, Close } from "@material-ui/icons";
import { apiGet, apiPost } from "../helpers/api";

// Components
import OfflineComponent from "../components/OfflineComponent";

const useStyles = makeStyles((theme) => ({
  grid: {
    "& .MuiBox-root > div": {
      justifyContent: "center",
    },
  },
  form: {
    marginTop: "20px",
    "& .MuiTextField-root": {
      width: "100% !important",
    },
  },
  toolbar: {
    margin: "0",
    top: "50%",
    transform: "translateY(-50%)",
  },
  appBar: {
    height: "10vh",
    backgroundColor: "#942424",
  },
  title: {
    flexGrow: 1,
    fontWeight: "bold",
    textAlign: "center",
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    backgroundColor: "#A3080C",
    padding: "24px",
    fontSize: 20,
    fontWeight: "bold",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#bd0d12",
      borderColor: "#564345",
    },
  },
  rating: {
    display: "inline !important",
  },
  box: {
    marginTop: "20px",
    textAlign: "center",
  },
  icon: {
    padding: "20px",
  },
  alert: {
    width: "80%",
  },
}));

function PickupType(props) {
  const classes = useStyles();

  const [done, setDone] = useState(false);
  const [delivery, setDelivery] = useState(null);
  const [error, setError] = useState("");

  const submitHandler = async (type) => {
    try {
      // send data to api endpoint
      await apiPost(
        `/deliveries/pickup/${props.match.params.uuid}/pickup_type`,
        {
          pickup_type: type
        }
      );
    	setDone(true);
    } catch (err) {
      console.log(err.response?.data?.message);
    }
  };

  if (!props.match.params.uuid) {
    // redirect if uuid is missing
    window.location.href = "/";
  }

  const fetchData = async () => {
    const response = await apiGet(
      `/deliveries/${props.match.params.uuid}/public`
    );
    setDelivery(response.data.data);
  };

  useEffect(() => {
    fetchData();
  }, [done]);

  const renderAlreadySetPickupType = () => (
    <div style={{ padding: "20px", display: "block" }}>
      <Box component="span" display="block">
        <Typography variant="h6" style={{ textAlign: "center", marginBottom: 15}}>
			Thank you for ordering
        </Typography>
        <Typography variant="h5" style={{ textAlign: "center" }}>
          Please pickup your order at {delivery.pickupType}
        </Typography>
      </Box>
    </div>
  );

  const renderForm = () => {
    return (
      <>
        <div style={{ padding: "20px", display: "block", width: "80%" }}>
          <Box component="span" display="block" className={classes.box}>
            <Button
              type="button"
              disableElevation
              variant="contained"
              fullWidth
              className={classes.submit}
              onClick={() => submitHandler("counter")}
            >
              I'll pick it up at the counter
            </Button>
          </Box>
          <Box component="span" display="block" className={classes.box}>
            OR
          </Box>
          <Box component="span" display="block" className={classes.box}>
            <Button
              type="button"
              disableElevation
              variant="contained"
              fullWidth
              className={classes.submit}
              onClick={() => submitHandler("drive-thru")}
            >
              I'll pick it up at drive-thru
            </Button>
          </Box>
        </div>
      </>
    );
  };

  const renderContent = () => {
    if (!delivery) {
      return null;
    }

    if (done || delivery.pickupType) {
      return renderAlreadySetPickupType();
    }

    return renderForm();
  };

  return (
    <>
      <OfflineComponent />
      <AppBar position="static" className={classes.appBar}>
        <Toolbar className={classes.toolbar}>
          <Typography variant="h6" className={classes.title}>
            How do you want to claim your order?
          </Typography>
        </Toolbar>
      </AppBar>

      <Grid
        container
        justify="center"
        style={{ marginTop: "100px" }}
        className={classes.grid}
      >
        {renderContent()}
      </Grid>
    </>
  );
}

export default PickupType;
